import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CatalogCustomer } from "../models/CatalogCustomer";

export const getCatalogCustomers = async (): Promise<CatalogCustomer[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[FAB].[GetCustomers]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CatalogCustomer[];
	}
	throw new Error(resp.message || "Error fetching catalog customers");
};

export const upsertCatalogCustomer = async (customer: CatalogCustomer) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "CustomerId", value: customer.CustomerId },
		{ name: "CustomerName", value: customer.CustomerName },
		{ name: "Enabled", value: customer.IsActive },
	];
	return await apiService.callV2("[FAB].[UpsertCustomer]", parameters);
};

export const deleteCatalogCustomer = async (customerId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "CustomerId", value: customerId }];
	return await apiService.callV2("[FAB].[DeleteCustomer]", parameters);
};
